import { render, staticRenderFns } from "./RFPDetailsBOQ.vue?vue&type=template&id=4ec32a38&scoped=true"
import script from "./RFPDetailsBOQ.vue?vue&type=script&lang=js"
export * from "./RFPDetailsBOQ.vue?vue&type=script&lang=js"
import style0 from "./RFPDetailsBOQ.vue?vue&type=style&index=0&id=4ec32a38&prod&lang=css"
import style1 from "./RFPDetailsBOQ.vue?vue&type=style&index=1&id=4ec32a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec32a38",
  null
  
)

export default component.exports